import { faFlowerTulip } from "@jewlr/pro-light-svg-icons/faFlowerTulip"
import { faGem } from "@jewlr/pro-light-svg-icons/faGem"
// import { faGift } from "@jewlr/pro-regular-svg-icons/faGift"
// import { faPlane } from "@jewlr/pro-regular-svg-icons/faPlane"
// import { faBoxHeart } from "@jewlr/pro-regular-svg-icons"
import {
  Flex,
  FontAwesomeIcon,
  Shimmer,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import { jewlr_t } from "helpers/application"

const Container = styled(Flex)`
  align-items: center;
  background: ${(props) =>
    props.holidayDelivery ? "#FCF2F2" : "rgba(0, 136, 0, 0.05)"};
  border-radius: 5px;
  gap: 4px;
  height: 32px;
  justify-content: center;
  margin-bottom: 24px;
`

const PromoText = styled(Typography)`
  color: ${(props) =>
    props.holidayDelivery
      ? props.theme.colors.sale
      : props.theme.colors.greenDarker};
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.03em;
`

const PromoDesktop = ({
  doubleJewlsPromo,
  doubleJewlsPromoMessage,
  holidayDelivery,
  ship,
  wizardLoading,
}) => {
  if (!doubleJewlsPromo && !holidayDelivery) {
    return null
  }

  if (wizardLoading) {
    return <Shimmer height="32px" mb={2} />
  }

  let message = doubleJewlsPromoMessage
  if (holidayDelivery) {
    let dateMsg =
      ship.delivery_dates?.length > 0 ? ship.delivery_dates[0].date : ""
    message = (
      <>
        {/* <strong>Arrives before {sl.config.guaranteed_holiday}</strong> */}
        <strong>
          {sl.config.guaranteed_holiday} {jewlr_t("terms.Shipping")} Info
        </strong>
        {dateMsg && (
          <>
            {" "}
            - Get it by <strong>{dateMsg}</strong>
          </>
        )}
      </>
    )
  }

  return (
    <Container>
      <FontAwesomeIcon
        color={holidayDelivery ? "sale" : "greenDarker"}
        icon={holidayDelivery ? faFlowerTulip : faGem}
        width="13px"
      />
      <PromoText>{message}</PromoText>
    </Container>
  )
}

PromoDesktop.propTypes = {
  doubleJewlsPromo: PropTypes.bool,
  doubleJewlsPromoMessage: PropTypes.string,
  holidayDelivery: PropTypes.bool,
  ship: PropTypes.object,
  wizardLoading: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    doubleJewlsPromo: state.wizard.promo_double_jewls,
    doubleJewlsPromoMessage: state.wizard.promo_double_jewls_messaging,
    holidayDelivery:
      state.wizard.shipping.main?.available_holiday_delivery &&
      state.wizard.forHer,
    ship: state.wizard.shipping.main,
    wizardLoading: state.wizard.loading,
  }
}

export default connect(mapStateToProps)(PromoDesktop)
